/**
 * 方括号金额自动换算组件：
 * - 配合 snippets/fanka-bracket-price.liquid 使用，读取内部 .fanka-bracket-price__amount
 *   元素的 data-amount（原始金额数字）/ data-display（服务端 money filter 格式化后的回退文案）
 * - 根据 window.Shopify.currency.rate（店铺后台"国际买家货币转换"注入的全局对象）算出
 *   实时汇率金额，向上取整后替换 data-display 里的数字部分，保留服务端渲染好的货币符号/千分位格式
 */
class FankaBracketPrice extends HTMLElement {
  connectedCallback() {
    this.convertPrices();
  }

  convertPrices() {
    const priceElements = this.querySelectorAll('.fanka-bracket-price__amount');
    if (!priceElements.length) return;

    if (!window.Shopify?.currency?.active) {
      // 货币信息未就绪，延迟 100ms 重试
      setTimeout(() => this.convertPrices(), 100);
      return;
    }

    const rate = parseFloat(window.Shopify.currency.rate) || 1;

    priceElements.forEach((el) => {
      const amount = parseFloat(el.getAttribute('data-amount'));
      const display = el.getAttribute('data-display');

      if (!isNaN(amount)) {
        el.textContent = this.formatAmount(amount, rate, display);
      }
      el.style.opacity = '1';
    });
  }

  formatAmount(amount, rate, display) {
    const converted = Math.ceil(amount * rate).toFixed(2);
    return display.replace(/[\d,.]+/, converted);
  }
}

customElements.define('fanka-bracket-price', FankaBracketPrice);
